import {IconButton} from '@wandb/components';
import React, {useCallback, useMemo} from 'react';

import {getPanelsPerPage} from '../resizeUtils';
import {useWorkspaceSectionLayoutConfigs} from '../WorkspaceSectionLayoutConfigs';
import {PanelBankSectionPaginationMenu} from './PanelBankSectionPaginationMenu';

export const PanelBankSectionPagination = ({
  activePanelCount,
}: {
  activePanelCount: number;
}) => {
  const {
    columnsPerPage,
    currentPage,
    flowConfig,
    initialRowsPerPage: rowsPerPage,
    maxNumSectionPages,
    setCurrentPage,
    updateFlowConfig,
  } = useWorkspaceSectionLayoutConfigs();

  const panelsPerPage = useMemo(
    () => getPanelsPerPage({columnsPerPage, rowsPerPage}),
    [columnsPerPage, rowsPerPage]
  );

  const startPanelIndex = useMemo(
    () => currentPage * panelsPerPage,
    [currentPage, panelsPerPage]
  );

  const setNextPage = useCallback(() => {
    setCurrentPage(currentPage + 1);
  }, [currentPage, setCurrentPage]);

  const setPreviousPage = useCallback(() => {
    setCurrentPage(currentPage - 1);
  }, [currentPage, setCurrentPage]);

  if (activePanelCount <= columnsPerPage) {
    return null;
  }

  return (
    <div
      className="flex items-center"
      data-test="panel-bank-section-pagination">
      <PanelBankSectionPaginationMenu
        flowConfig={flowConfig}
        panelsPerPage={panelsPerPage}
        startPanelIndex={startPanelIndex}
        updateFlowConfig={updateFlowConfig}
        numTotalPanelsInSection={activePanelCount}
      />
      <IconButton
        isDisabled={currentPage === 0}
        aria-label="Previous page"
        icon="chevron-back"
        onPress={setPreviousPage}
        size="md"
        variant="ghost"
      />
      <IconButton
        isDisabled={currentPage === maxNumSectionPages}
        aria-label="Next page"
        icon="chevron-next"
        onPress={setNextPage}
        size="md"
        variant="ghost"
      />
    </div>
  );
};
